import { FaMailBulk } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { IoIosLogOut } from "react-icons/io";
import { BiMailSend } from "react-icons/bi";
import { MdOutlineLockReset } from "react-icons/md";
import { PlusSquareOutlined } from "@ant-design/icons";
import { TbPasswordUser } from "react-icons/tb";
import { FaUserCog } from "react-icons/fa";
import { TbLayoutDashboard } from "react-icons/tb";
import { FaSortDown } from "react-icons/fa6";
import { FaSortUp } from "react-icons/fa6";
import { FcMoneyTransfer } from "react-icons/fc";
import { FcMultipleCameras } from "react-icons/fc";
import { FcRatings } from "react-icons/fc";
import { FcPanorama } from "react-icons/fc";

const icons = {
  FaMailBulk,
  IoMdClose,
  IoIosLogOut,
  BiMailSend,
  MdOutlineLockReset,
  PlusSquareOutlined,
  TbPasswordUser,
  FaUserCog,
  TbLayoutDashboard,
  FaSortDown,
  FaSortUp,
  FcMoneyTransfer,
  FcMultipleCameras,
  FcPanorama,
  FcRatings,
};

export default icons;
